<script setup>
import { useMainStore } from '@/store/index'
import CookieNotice from '@/components/alerts/CookieNotice.vue'
const { locale } = useI18n()

const localeCookie = useCookie('LOCALE')
const currentLocale = localeCookie.value
if (currentLocale) {
    locale.value = currentLocale
}

const mainStore = useMainStore()
const embedOptions = mainStore.embedOptions
embedOptions.embed = false

const { $setSize } = useNuxtApp()

const onResize = () => {
    $setSize()
}

const onOrientationChange = () => {
    $setSize()
}

const onLoad = () => {
    $setSize()
    window.dispatchEvent(new Event('resize'))
}

onMounted(async () => {
    $setSize()
    window.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', onOrientationChange)
    window.addEventListener('load', onLoad)

    await nextTick(() => {
        $setSize()
    })
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
    window.removeEventListener('orientationchange', onOrientationChange)
    window.removeEventListener('load', onLoad)
})
</script>
<template>
    <div>
        <NuxtLoadingIndicator color="#aaa" />
        <slot />
        <Foot><LanguageSwitcher /></Foot>
        <CookieNotice />
    </div>
</template>
